// src/schemas/servicesSchema.js

export const servicesBreadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://cfobridge.ae/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Our Services",
      "item": "https://cfobridge.ae/services"
    }
  ]
};

export const servicesFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What outsourced financial and compliance services do you offer in the UAE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our outsourced financial and compliance services in the UAE cover the full spectrum of CFO-level support, including Virtual and Interim CFO Services, E-Invoicing Setup and Compliance, Company Setup and Winding Down, Working Capital Management, M&A and Fundraising advisory, IPO Readiness, ERP Implementation, and AML, Corporate Tax, and VAT compliance guidance for businesses operating across Dubai, Abu Dhabi, and the wider MENA region."
      }
    },
    {
      "@type": "Question",
      "name": "How does your 5-Pronged Approach optimize business cash flow and profitability?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our 5-Pronged Approach addresses five critical levers of business financial health: cash conversion efficiency, cost structure optimisation, revenue cycle management, working capital deployment, and strategic financial forecasting. By systematically improving each lever, our fractional CFOs help UAE businesses unlock trapped liquidity, reduce burn rates, and drive sustainable profitability."
      }
    },
    {
      "@type": "Question",
      "name": "Can I hire a fractional CFO for a single project like ERP implementation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Our fractional CFO model is designed for project-based engagements. Whether you need a CFO to lead a full ERP implementation, oversee a one-time audit readiness review, or manage a specific compliance project, CFO Bridge UAE can deploy an experienced CFO Partner for the duration of the project without any long-term retainer commitment."
      }
    },
    {
      "@type": "Question",
      "name": "Do your services include UAE Corporate Tax, VAT, and AML compliance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Our compliance services specifically cover UAE Corporate Tax (CT) registration and structuring, VAT return filing and advisory, and Anti-Money Laundering (AML) policy implementation and compliance reviews. Our specialists ensure your business meets all regulatory requirements set by the Federal Tax Authority (FTA) and relevant UAE authorities."
      }
    },
    {
      "@type": "Question",
      "name": "How quickly can an interim CFO integrate into our UAE business operations?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our interim CFOs follow a structured onboarding framework that includes a rapid financial health assessment, stakeholder alignment sessions, and an immediate 30-day action plan. This approach allows them to become productive contributors within the first week of engagement, minimising disruption to your operations."
      }
    },
    {
      "@type": "Question",
      "name": "How do your fractional CFOs prepare a business for M&A and fundraising?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our fractional CFOs support M&A and fundraising readiness by preparing investor-grade financial models, conducting due diligence readiness assessments, structuring financial statements to meet buyer or investor expectations, and advising on deal structuring. They work alongside legal and investment banking advisors to ensure your financial narrative is compelling and defensible."
      }
    },
    {
      "@type": "Question",
      "name": "What is the difference between your virtual CFO and tax advisory services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Virtual CFO services provide ongoing strategic financial leadership — covering planning, reporting, cash flow management, and board-level advisory on a remote, flexible basis. Tax advisory services are focused specifically on UAE Corporate Tax, VAT compliance, and AML obligations. Many clients engage both services together to get comprehensive financial and regulatory coverage."
      }
    }
  ]
};